import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyDojEM2vaIn18HsLbnl2zCkTbYGVWPVgi4",
    authDomain: "fight-ae993.firebaseapp.com",
    projectId: "fight-ae993",
    storageBucket: "fight-ae993.firebasestorage.app",
    messagingSenderId: "587605632748",
    appId: "1:587605632748:web:neodia-ad-web"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Collection names
export const FIREBASE_COLLECTIONS = {
    ADS: 'ads',
    PAYMENTS: 'payments'
} as const; 